import { render, staticRenderFns } from "./InputSizeProperty.vue?vue&type=template&id=833b48ce&"
import script from "./InputSizeProperty.vue?vue&type=script&lang=js&"
export * from "./InputSizeProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports